import * as React from "react";
import { PropertyFiltersComponentProps } from "../typings";
import { UitkRadio } from "uitk-react-switch";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { PROPERTY_FILTERS } from "components/flexComponents/PropertyFilters/PropertyFilters";
import { withStores } from "src/stores";
import { observer } from "mobx-react";

const RadioButtonTracked = FlexClickTracker(UitkRadio);

export const Radio = withStores(
  "propertyFilters",
  "wizardState"
)(
  observer((props: PropertyFiltersComponentProps) => {
    const { filterName, option, propertyFilters, wizardState, moduleName } = props;

    const onChange = () => {
      const regionId = propertyFilters.toggleSelection(filterName, option.optionValue!);

      if (regionId) {
        wizardState?.hotelWizardState?.setRegionId(regionId);
      }
    };

    const isSelected = propertyFilters.isSelected(filterName, option.optionValue!);

    return (
      <RadioButtonTracked
        events="click"
        id={`${filterName}-${option.optionValue}`}
        label={option.label}
        moduleName={PROPERTY_FILTERS}
        rfrr={`${moduleName}.${filterName}.${option.optionValue}.${!isSelected}`}
        value={option.optionValue}
        checked={isSelected}
        onChange={onChange}
        description={option.description}
        autoComplete="off"
      />
    );
  })
);
